module.exports = __webpack_public_path__ + "7c88fa6498abce74a082ba7fd4fa90ed.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/Characters/monkey.png
// module id = 636
// module chunks = 0